import _objectWithoutProperties from "/home/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["children", "isOpened", "isSearchActive"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import { Button as ButtonBase, Text } from '@miro-site/core';
import { Categories, Close } from '../../icons/Icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Button = styled(ButtonBase).withConfig({
  displayName: "Button",
  componentId: "sc-1at222n-0"
})(["display:flex;justify-content:flex-start;align-items:center;&:hover{color:var(--wcds-colors-white);", "{color:var(--wcds-colors-white);}}&:focus{", "}"], Text, function (_ref) {
  var theme = _ref.theme;
  return theme.normalizeStyles(_objectSpread({}, theme.focus.outlines["default"]));
});
var CategoryButton = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      isOpened = _ref2.isOpened,
      isSearchActive = _ref2.isSearchActive,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_jsxs(Button, _objectSpread(_objectSpread({
    "data-track-id": "category-menu-button",
    $buttonType: "secondary",
    $size: "small",
    ref: ref,
    $styles: {
      position: isSearchActive ? 'absolute' : 'relative',
      border: '1px solid var(--wcds-templates-category-button-border-color)'
    }
  }, props), {}, {
    children: [isOpened ? /*#__PURE__*/_jsx(Close, {
      width: 20,
      height: 20
    }) : /*#__PURE__*/_jsx(Categories, {
      width: 20,
      height: 20
    }), /*#__PURE__*/_jsx(Text, {
      as: "span",
      $ml: 7,
      $variant: "p2",
      children: children
    })]
  }));
});
CategoryButton.displayName = 'CategoryButton';
export default CategoryButton;